import { removeEmptyEntries } from '../../../../utils';
import tracker from '../../../../utils/reports/TrackingService';
import { EVENTS } from './constants';

export const reportMixpanelEvent = ({ position, username, isBusinessReview = false }) => {
    tracker.sendMixPanelEvent({
        eventName: EVENTS.Mixpanel,
        eventPayload: removeEmptyEntries({
            Position: position,
            Reviewer: username,
            Business: isBusinessReview,
        }),
    });
};
